import { Identifier } from '../../models';
import { IDENTIFIERS_LOAD_SUCCESS, IDENTIFIERS_LOAD, IDENTIFIER_DUPLICATE, IDENTIFIER_DUPLICATE_SUCCESS, IDENTIFIER_DUPLICATE_ERROR, IDENTIFIER_DELETE } from './identifiers.constants';

export function loadIdentifiers() {
    return { type: IDENTIFIERS_LOAD };
}

export function loadIdentifiersSuccess(data: Identifier[]) {
    return { type: IDENTIFIERS_LOAD_SUCCESS, payload: data };
}

export function deleteIdentifier() {
    return { type: IDENTIFIER_DELETE };
}

export function duplicateIdentifier() {
    return { type: IDENTIFIER_DUPLICATE };
}

export function duplicateIdentifierSuccess(payload: any) {
    return { type: IDENTIFIER_DUPLICATE_SUCCESS, payload: payload };
}

export function duplicateIdentifierError(payload: any) {
    return { type: IDENTIFIER_DUPLICATE_ERROR, payload: payload };
}